module.exports = __webpack_public_path__ + "static/llisa-hundley-182b3f5dfe2069122809b5a1a5434a61.png";